export const routes = {
    videoChat: ``,
    player: `player`,
    messenger: `messenger`,
    error: `error`,
    online: `online`
};